module.exports = __webpack_public_path__ + "img/1440.2ac5a109.jpg";